import _ from 'lodash';

export const getCoupons = (state, partnerId) =>
    partnerId && state.coupon.coupons && state.coupon.coupons[partnerId]
        ? state.coupon.coupons[partnerId]
        : null;

export const getCoupon = (state, partnerId, couponId) => {
    const coupons = getCoupons(state, partnerId);
    const couponIdInt = Number(couponId);
    return coupons && _.isNumber(couponIdInt) ? coupons.find(c => c.id === couponIdInt) : null;
};



// WEBPACK FOOTER //
// ./src/services/coupon/selector.js